import React from "react";
// React Bootstrap
import { Container, Col, Row, Image, Card, Button } from "react-bootstrap";
import styled from "styled-components";
// Utils
import { handleOnImg404 } from "../../utils";
import $ from "jquery";
import { useHistory } from "react-router-dom";

const CustomCardTextCenter = styled(Card.Text)`
  text-align: center;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  height: 1.563rem;
  margin-bottom: 0.25rem;
`;

const ComunidadInfo = ({ datosComunidad, idProvincia, idComunidad }) => {

  //102022
  let history = useHistory();

  const deleteCommunity = async (id) => {
    let settings = {
      url: `${process.env.REACT_APP_API_URL}/provincias/${idProvincia}/comunidades/${id}`,
      method: "DELETE",
      xhrFields: {
        withCredentials: true,
      },
    };
    $.ajax(settings)
    history.push(`/provincias/${idProvincia}/comunidades`)
    history.go(0);
  }

  return (
    <Container fluid className="shadow-lg my-5 ">
      <Row>
        {(datosComunidad?.name === '- Edite la NUEVA comunidad -') && <Button variant="danger" onClick={() => {
          deleteCommunity(datosComunidad?.id)

        }}>Elimina nueva comunidad</Button>}
        <Col>
          <Image
            style={{ objectFit: "contain" }}
            className="img-fluid-detalle"
            variant="top"
            src={
              datosComunidad.photo
                ? `${process.env.REACT_APP_API_URL}/download/provincias/${idProvincia}/comunidades/${idComunidad}?r=${datosComunidad.photo}`
                : `/images/provincias/${idProvincia}.png`
            }
            onError={(e) => handleOnImg404(e, "/images/logoSTJ.png")}
            alt="misionImg"
          />
        </Col>
        <Col className="d-flex align-items-center">
          <Container>
            <Row noGutters>
              <h5>{datosComunidad?.name || <small>No especificado</small>}</h5>
            </Row>
            <Row noGutters>
              <CustomCardTextCenter title={datosComunidad?.city}>
                {`${datosComunidad?.city}${datosComunidad?.country ? datosComunidad?.country ? ', ' : '' : ''} ${datosComunidad?.country ? datosComunidad?.country : ''}`}

              </CustomCardTextCenter>
            </Row>
          </Container>
        </Col>
      </Row>
    </Container>
  );
};

export default ComunidadInfo;
